import { defineStore, acceptHMRUpdate } from 'pinia'
import { searchRecordList, hotWord, search, deleteOneSearchRecord, deleteAllSearchRecord } from '@/api/index'

const useSearchStore = defineStore('search', {
  state: () => ({
    searchKeyWord: '',//搜索关键词
    searchRecordList: [], //搜索记录列表
    hotWords: [], //热词
    seachResultList: [],//搜索结果

    current: 1,//当前分页
    totalCount: 0,
    pageBean: {}, //分页相关数据
    type: null,// 资源类型,传入null为全类型搜索 微课–minute_course 文档–document 研修–train
  }),
  actions: {
    //搜索记录列表
    async getSearchRecordList () {
      const res = await searchRecordList()
      if (res.code == 0) {
        this.searchRecordList = res.data.slice(0, 8)
      }
    },
    // 获取热搜词
    async getHotWord () {
      const res = await hotWord()
      if (res.code == 0) {
        this.hotWords = res.data.slice(0, 8)
      }
    },
    //  分词搜索
    async getSeach (item = this.searchKeyWord) {
      const res = await search({
        content: item, //搜索内容
        current: this.current, //当前页
        size: 10 ,//每页数
        type:this.type,
      })
      if (res.code == 0) {
        this.seachResultList = res.data.objList
        this.totalCount = res.data.pageBean.totalCount
        this.pageBean = res.data.pageBean
      }
    },

    // 删除一条搜索记录
    async deleteOneSearchRecordM (id) {
      const res = await deleteOneSearchRecord({ id })
      if (res.code == 0) {
        console.log('1111')
      }

    },
    //删除所有搜索记录
    async deleteAllSearchRecordM () {
      const res = await deleteAllSearchRecord()
      if (res.code == 0) {
        console.log('1111')
      }
    }
  }

})



export default useSearchStore